import './Buscar.css';

export default function BotonOpcion({ icono, titulo, descripcion, extra, role, onClick }) {
  return (
    <button type="button" className="buscar-choice" onClick={onClick} role={role}>
      <span className="buscar-choice-icon" aria-hidden="true">{icono}</span>
      <span style={{ flex: 1 }}>
        <span className="buscar-choice-title">{titulo}</span>
        {descripcion && <span className="buscar-muted">{descripcion}</span>}
      </span>
      {extra}
    </button>
  );
}